import {handleActions} from 'redux-actions';
import {ParentalStatusSurvey} from '../constants/models';

const  ParentalStatusSurveyReducers = handleActions({
    SET_PARENTAL_STATUS_SURVEY: (state, {payload}) => (
        state.merge({
            data: payload
        })
    ),
}, ParentalStatusSurvey);

export default ParentalStatusSurveyReducers;


// WEBPACK FOOTER //
// ./src/dashboards_redux/reducers/ParentalStatusSurveyReducers.jsx